import React, { useContext } from "react";
import styled from "styled-components";
import { APIContext } from "../../contexts/APIContext";
const GraphicButton = styled.div`
  display: flex;
  align-items: center;
  background-color: ${(props) =>
    props.green
      ? "#0adb93"
      : props.red
      ? "#db0a41"
      : props.layout === "middle"
      ? "#202731"
      : "#181d25"};
  color: ${(props) => (props.green ? "#1d1d1d" : "")};
  min-height: 50px;
  box-sizing: border-box;
  border-radius: 4px;
  margin-top: 1em;
  justify-content: center;
  align-items: center;
  text-align: center;
  cursor: pointer;
  :hover {
    background-color: ${(props) =>
      props.green ? "#0adb93" : props.red ? "#db0a41" : "#db0a41"};
  }
`;
function Standings({ component, game, previewGraphic }) {
  const { getStandings } = useContext(APIContext);
  return (
    <GraphicButton
      onClick={async () => {
        let standings = await getStandings({
          season: game?.season?._id,
          date: game.date?.replace("Z", ""),
        });
        if (
          component?.data?.options?.type === "MINI" &&
          component?.data?.options?.section === "TOP"
        ) {
          previewGraphic("MiniStandings", {
            game,
            standings,
            type: "TOP",
          });
        } else if (
          component?.data?.options?.type === "MINI" &&
          component?.data?.options?.section === "BOTTOM"
        ) {
          previewGraphic("MiniStandings", {
            game,
            standings,
            type: "BOTTOM",
          });
        } else {
          previewGraphic("Standings", {
            game,
            standings,
          });
        }
      }}
    >
      {component?.data?.label}
    </GraphicButton>
  );
}

export default Standings;
